import axios from "axios";
import Cookies from "js-cookie";

// Create a reusable Axios instance
const apiClient = axios.create({
    baseURL: "https://viaggioerp.inter-netsys.com",
    timeout: 10000000,
});

/**
 * Merge default headers with custom headers
 * @param {Object} customHeaders - Optional custom headers
 * @returns {Object} - Combined headers
 */
const getHeaders = (customHeaders = {}) => {
    return {
        "Content-Type": "application/json",
        ...customHeaders,
    };
};

/**
 * Get preferred language from cookies
 * @returns {string}
 */
const getPreferredLanguage = () => {
    return Cookies.get("preferred_language") || "en";
};
const getPreferredCurrency = () => {
    return Cookies.get("preferred_currency") || "AED";
};
/**
 * Perform a GET request
 */
export const axiosGet = async (url, params = {}, headers = {}) => {
    try {
        const response = await apiClient.get(url, {
            params: {
                preferred_language: getPreferredLanguage(),
                preferred_currency: getPreferredCurrency(),
                ...params,
            },
            headers: getHeaders(headers),
        });
        return response.data;
    } catch (error) {
        handleAxiosError(error);
    }
};

/**
 * Perform a POST request
 */
export const axiosPost = async (url,data, headers = {}) => {
    // #omar fix preferred language for post
    if (data.preferred_language === undefined || !data.preferred_language){
        data.preferred_language = getPreferredLanguage()
    }
    if(typeof data !== 'string')
    {
        data = JSON.stringify(data);
    }

    try {
        const response = await apiClient.post(url, data, {
            headers: getHeaders(headers),
        });
        return response;
    } catch (error) {

      handleAxiosError(error);
      throw error;
    }
};

/**
 * Perform a PUT request
 */
export const axiosPut = async (url, data, headers = {},  params = {}) => {
    try {
        if (data.preferred_language === undefined || !data.preferred_language){
            data.preferred_language = getPreferredLanguage()
        }
        if(typeof data !== 'string')
        {
            data = JSON.stringify(data);
        }

        const response = await apiClient.put(url, data, {
            headers: getHeaders(headers),
        });
        return response;
    } catch (error) {
        handleAxiosError(error);
    }
};

/**
 * Perform a DELETE request
 */
export const axiosDelete = async (url, params = {}, headers = {}) => {
    try {
        const response = await apiClient.delete(url, {
            params: {
                preferred_language: getPreferredLanguage(),
                ...params,
            },
            headers: getHeaders(headers),
        });
        return response;
    } catch (error) {
        handleAxiosError(error);
    }
};

/**
 * Handle Axios errors
 */
  const handleAxiosError = (error) => {
    const Lang = Cookies.get("preferred_language") || "en";

    if (error.code === "ERR_NETWORK") {
        throw new Error(Lang==="ar"? "لا يوجد اتصال بالإنترنت. يُرجى التحقق من شبكتك.":
            "No internet connection. Please check your network.");
    }
  
    if (error.response) {
      const responseData = error.response.data;  
      if (responseData?.result) {
        throw new Error(responseData.result);
      } else {
        throw new Error(responseData?.message || (Lang==="ar"?"حدث خطأ. يرجى المحاولة مرة أخرى لاحقًا.": "An Error Occured"));
      } 
      }
  
    throw new Error(error.message || (Lang==="ar"?"حدث خطأ. يرجى المحاولة مرة أخرى لاحقًا.": "An Error Occured"));
  };
  